import type { EditRequestFormData, UpdateRequestById } from "@nlc/shared-types";

import { CalendarDate } from "@internationalized/date";

export function prepareForApi(
  formData: Partial<EditRequestFormData>,
): Partial<UpdateRequestById> {
  const apiData = { ...formData } as Partial<UpdateRequestById>;

  if (formData.dueDate instanceof CalendarDate) {
    apiData.dueDate = formData.dueDate.toDate("America/New_York");
  }

  if (formData.internalDueDate instanceof CalendarDate) {
    apiData.internalDueDate =
      formData.internalDueDate.toDate("America/New_York");
  }

  return apiData;
}
